import React, { Component, useState, useEffect } from "react";
import { Nav, Navbar, Form, FormControl, Button } from "react-bootstrap";
import { NavLink, useHistory } from "react-router-dom";
import "./NavigationBar.css";
import { MdSettings } from "react-icons/md";
import { MdAccountBox } from "react-icons/md";
import Logo from "../../images/logo.svg";
import ProfileIcon from "../../images/Profile Icon.svg";
import FMLogo from "../../images/FMLogo.svg";
import { withRouter } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { Button as MatButton } from "@material-ui/core";
import {
  isProjectRole,
  isReadonlyRole,
  getTranslatedRoleMap,
  isProjectStandardRole,
  isLenderRole,
  isTPORole,
  isAdminRole,
  isInternal ,
  isProjectReadOnlyRole
} from "../../redux/actions/userAction";
import { getLogoutUrl } from "../shared/constants/environment";
import { isAuthenticated } from "../shared/services/SharedService";
import {
  resolveStoredRole,
  setStoredRole,
} from "../shared/services/AuthSessionService";

// class NavigationBar extends Component {

import CancelModal from "./cancel-modal";
import { CPM_REQUEST_GRID_INTERNAL, CPM_REQUEST_GRID_EXTERNAL} from "../shared/constants/FeatureToggleKeys";
import withFeatureFlagUpdates from "../shared/services/featureToggle/withFeatureFlagUpdates";

const NavigationBar = (props) => {
  const [dialogueOpen, setDialogueOpen] = useState(false);
  const [userRole, setUserRole] = useState("");
  const [lenderName, setLenderName] = useState("");
  const history = useHistory();
  const [forceCount, setForceCount] = useState(false); //to update states for add new project case
  const dispatch = useDispatch();
  const [isHideHeader, setIsHideHeader] = useState(false);
  const [intitalState, setInitialState] = useState(true);

  const userDetails = useSelector(
    (store) => store.getUserDetailsReducer.userDetails
  );

  const roleDetails = useSelector(
    (store) => store.getUserDetailsReducer.roleDetails
  );
  const [showCancel, setShowCancel] = useState(false);
  const [link, setLink] = useState("/");
  const [isLogo, setIsLogo] = useState(false);
  
  React.useEffect(() => {
    setIsHideHeader(window.location.pathname === "/session-error-page");

    if (intitalState && window.location.pathname !== "/session-error-page" && isAuthenticated()) {
      dispatch(getTranslatedRoleMap());
      setInitialState(false);
    }
  }, []);

  React.useEffect(() => {
    if (window.location.pathname === "/session-error-page" || !isAuthenticated()) {
      return;
    }

    getUserRole();
  }, [roleDetails]);

  function getUserRole() {
    const roleMap = roleDetails && roleDetails.hashedRoleMap;
    const selectedRole = roleDetails && roleDetails.selectedRole;
    const resolvedRole = resolveStoredRole(roleMap, selectedRole);

    if (resolvedRole) {
      setUserRole(resolvedRole);
      setStoredRole(resolvedRole);
    }

    setInitialState(true);
  }

  function changeRole(e) {
    const nextRole = e.target.value;

    setUserRole(nextRole);
    props.dialogueCallback(nextRole);
    setStoredRole(nextRole);

    let path = window.location.pathname;
    let selectedRole = nextRole;

    if (
      selectedRole &&
      selectedRole.substring(selectedRole.length - 3, selectedRole.length) ===
      "-RO"
    ) {
      if (path === "/addNewProject" || path === "/addNewProject/new") {
        history.replace("/");
        return;
      }
    }

    if (path !== "/error-page") {
      window.location.reload();
    }
  }

  function handleCancelCancel() {
    setShowCancel(false);
  }

  function leaveLose() {
    setShowCancel(false);
    if (link == "/addNewProject") {
      window.location.reload();
    }
  }

  function setLender(e) {
    setLenderName(e.target.value);
    setInitialState(true);
    //setting it to session now to leverage later
    sessionStorage.setItem("lenderId", e.target.value);
  }

  let path = window.location.pathname;
  let splitArr = path.split("/");
  let isFinalApproval = splitArr[1];

  if (userDetails.roles) {
    // dispatch(getTranslatedRoleMap(userDetails.roles));
  }

  const roleKeys =
    roleDetails &&
    roleDetails.hashedRoleMap &&
    Object.keys(roleDetails.hashedRoleMap);
  const lenderKeys =
    roleDetails &&
    roleDetails.associatedLenderMap &&
    Object.keys(roleDetails.associatedLenderMap);

  const clearSessionStorage = () => {
    Object.keys(sessionStorage).forEach((key) =>
      sessionStorage.removeItem(key)
    );
  };

  const handleLogout = () => {
    window.location.replace(getLogoutUrl(userDetails));
    clearSessionStorage();
  };

  const shouldShowRequestsLink = () => {
    return (
      ((isLenderRole() || isTPORole()) && props.isFeatureEnabled(CPM_REQUEST_GRID_EXTERNAL)) ||
      ((isInternal() || isProjectReadOnlyRole()) && props.isFeatureEnabled(CPM_REQUEST_GRID_INTERNAL))
    );
  };

  //for displaying a shorter name in the option
  const displayShortenedLenderName = (lenderName = "") => {
    // shortening it for over 35 characters for now, we can maintain a config if needed to decide the length
    if (lenderName.length < 35) return lenderName;
    return `${lenderName.substring(0, 35)}...`;
  };

  const renderLenderDropdown = () => {
    return isLenderRole() || isTPORole() ? (
      <>
        <Nav.Link className="lender">
          {isTPORole() ? (<span>Correspondent:</span>) : (<span>Lender:</span>)}
        </Nav.Link>
        <span>
          {" "}
          {lenderKeys && lenderKeys.length > 0 ? (
            <select
              required
              aria-label="lender name and id"
              name="lender"
              id={"lender-id"}
              style={{
                backgroundColor: "transparent",
                color: "#ffffff",
                border: "none",
                fontSize: 14,
                paddingLeft: 0,
                width: 200,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={"Select for Lender"}
              className="lender-select form-control"
              value={lenderName}
              onChange={(event) => {
                setLender(event);
              }}
            >
              {lenderKeys &&
                lenderKeys.map((lender, idx) => (
                  <option
                    className="styled-option"
                    style={{
                      color: "#000",
                    }}
                    value={lender}
                    key={lender - idx}
                  >
                    {displayShortenedLenderName(
                      roleDetails["associatedLenderMap"][lender]
                    )}
                  </option>
                ))}
            </select>
          ) : (
            <></>
          )}
        </span>
      </>
    ) : (
      ""
    );
  };

  return (
    <>
      <a className="skip-main" href="#main">
        Skip to main content
      </a>
      {isHideHeader ? (
        <></>
      ) : (
        <>
          <Navbar className="navbar-top">
            <Nav className="container-fluid nav-container">
              {renderLenderDropdown()}
              <Nav.Link
                className={
                  isLenderRole() || isTPORole() ? "user-profile-lender-view" : "user-profile"
                }
              >
                <img className="user-icon" src={ProfileIcon} alt="profile" />
                {userDetails.firstName} {userDetails.lastName}
              </Nav.Link>
              <Nav.Link className="user-role">
                <span>User Roles : </span>
              </Nav.Link>
              {roleDetails && roleKeys && roleKeys.length === 1 ? (
                <>
                  <span className="user-role">
                    {" "}
                    {roleDetails.hashedRoleMap[roleKeys[0]]}{" "}
                  </span>
                </>
              ) : (
                <>
                  {" "}
                  <select
                    required
                    aria-label="User Role"
                    name="state"
                    id={"stateid"}
                    style={{
                      backgroundColor: "transparent",
                      color: "#ffffff",
                      border: "none",
                      fontSize: 14,
                      paddingLeft: 0,
                      width: "auto",
                    }}
                    className="form-control"
                    value={userRole}
                    onChange={(event) => {
                      changeRole(event);
                      // setErrState(getRequiredErrorMsg(stateRef));
                    }}
                  >
                    {roleDetails &&
                      roleDetails.hashedRoleMap &&
                      roleKeys &&
                      roleKeys.map((eachRole, idx) => (
                        <option
                          value={eachRole}
                          key={idx}
                          style={{ color: "#000" }}
                        >
                          {roleDetails.hashedRoleMap[eachRole]}
                        </option>
                      ))}
                  </select>
                </>
              )}
              <Button
                style={{
                  fontFamily: "Source Sans Pro",
                  fontSize: "16px",
                  backgroundColor: "transparent",
                  borderColor: "transparent",
                }}
                onClick={handleLogout}
              >
                Logout
              </Button>
            </Nav>
          </Navbar>
        </>
      )}
      <CancelModal
        showCancel={showCancel}
        handleCancelCancel={handleCancelCancel}
        leaveLose={leaveLose}
        link={link}
        isLogo={isLogo}
      />
      {/* {isFinalApproval == "final-approval" ||
      isFinalApproval == "conditional-approval" ||
      isFinalApproval == "suspended" ||
      isFinalApproval == "ineligible-letter" ||
      isFinalApproval == "addNewProject" ? (
        <Navbar className="navbar-bottom">
          <Button
            className="brand-logo"
            style={{
              backgroundColor: "transparent",
              borderColor: "transparent",
              margin: 0,
              padding: 0,
              width: 40,
            }}
            onClick={() => {
              setLink("https://www.fanniemae.com/");
              setIsLogo(true);
              setShowCancel(true);
            }}
          >
            <img src={Logo} alt="Fannie Mae Logo" width="40" height="40" />
          </Button>
          <Button
            className="brand-button"
            style={{
              backgroundColor: "transparent",
              borderColor: "transparent",
              margin: 0,
              width: 180,
            }}
            onClick={() => {
              setLink("/");
              setShowCancel(true);
            }}
          >
            <div
              style={{
                height: 40,
                lineHeight: "175%",
                borderLeft: "2px solid #ffffff",
                paddingLeft: 10,
              }}
            >
              CPM
            </div>
          </Button>

          <Nav className="container-fluid">
            <Button
              className="dashboard-button"
              activeClassName="dashboard-button--active"
              style={{
                backgroundColor: "transparent",
                borderColor: "transparent",
              }}
              onClick={() => {
                setLink("/");
                setShowCancel(true);
              }}
            >
              Home
            </Button>
            {!isLenderRole() ? (
              <Button
                className="eligibility-list-button"
                activeClassName="eligibility-list-button--active"
                style={{
                  backgroundColor: "transparent",
                  borderColor: "transparent",
                }}
                onClick={() => {
                  setLink("/projects-list");
                  setShowCancel(true);
                }}
              >
                Projects List
              </Button>
            ) : (
              ""
            )}

            {isProjectStandardRole() ? (
              <MatButton
                className="add-new-project-button"
                onClick={() => {
                  setLink("/addNewProject");
                  setShowCancel(true);
                }}
              >
                Add New Project
              </MatButton>
            ) : null}
          </Nav>
        </Navbar>
      ) : ( */}
      <Navbar className="navbar-bottom">
        <Navbar.Brand
          className="brand-logo move-left"
          href="https://www.fanniemae.com/"
        >
          <img src={FMLogo} alt="CPM Logo" height="40" />
        </Navbar.Brand>
        <Nav className="container-fluid">
          <NavLink
            exact
            to="/"
            className="dashboard-button"
            activeClassName="dashboard-button--active"
            onClick={() => isHideHeader && (location.href = "/")}
          >
            Home
          </NavLink>         

          {shouldShowRequestsLink() ? (
            <NavLink
              to="/lender-project-request"
              className="requests-button"
              activeClassName="requests-button--active"
            >
              Requests
            </NavLink>
           ) : (
            <></>
          )}

          <NavLink
            to="/reports"
            className="reports-button"
            activeClassName="reports-button--active"
            onClick={() => isHideHeader && (location.href = "/reports")}
          >
            Reports
          </NavLink>
          
          {isProjectStandardRole() ? (
            <NavLink
              to="/banner-history"
              className="reports-button"
              activeClassName="reports-button--active"
            >
              Banners
            </NavLink>
          ) : (
            <></>
          )}

           {isAdminRole() ? (
            <NavLink
              to="/admin"
              className="reports-button"
              activeClassName="reports-button--active"
            >
              Admin
            </NavLink>
           ) : (
            <></>
          )}

          <NavLink
            to="/help-center"
            className={
              isProjectStandardRole() ? "help-button" : "help-button move-right"
            }
            activeClassName="help-button--active"
            onClick={() => isHideHeader && (location.href = "/help-center")}
          >
            Help Center
          </NavLink>
          {isProjectStandardRole() && !isReadonlyRole() ? (
            <MatButton
              className="add-new-project-button"
              onClick={() => {
                setForceCount((old) => !old);
                setInitialState(true);
                location.href = "/addNewProject/new";
              }}
            >
               Add New Project
            </MatButton>
          ) : null}
        </Nav>
      </Navbar>
      {/* // )} */}
    </>
  );
  // }
};

//
// export default withRouter(NavigationBar);
export default withFeatureFlagUpdates(NavigationBar, [
  CPM_REQUEST_GRID_INTERNAL,
  CPM_REQUEST_GRID_EXTERNAL
]);